import { RouteConfig } from "vue-router";
const companyIntroduction = () =>
  import("@/views/page/h5/companyIntroduction.vue");
const recruitmentInformation = () =>
  import("@/views/page/h5/recruitmentInformation.vue");
const onlineApplication = () => import("@/views/page/h5/onlineApplication.vue");
const treatmentDevelopment = () =>
  import("@/views/page/h5/treatmentDevelopment.vue");
const home = () => import("@/views/page/h5/home.vue");
const itineraryDetail = () => import("@/views/page/h5/itineraryDetail.vue");
const register = () => import("@/views/page/h5/register.vue");
const personal = () => import("@/views/page/h5/personal.vue");
const login = () => import("@/views/page/h5/login.vue");
const resume = () => import("@/views/page/h5/resume/my-resume.vue");
const deliver = () => import("@/views/page/h5/my-deliver.vue");
const deliverResume = () => import("@/views/page/h5/deliver-resume.vue");
const editPassword = () => import("@/views/page/h5/edit-password.vue");
const H5joblist = () => import("@/views/page/h5/joblist.vue");
const forgetPassword = () => import("@/views/page/h5/forgetPassWord.vue");
const welfare = () => import("@/views/page/h5/welfare.vue");

const pageRoute: Array<RouteConfig> = [
  //手机端页面
  {
    path: "home",
    meta: {
      title: "h5主页",
    },
    component: home,
  },
  {
    path: "itineraryDetail",
    meta: {
      title: "简章页",
    },
    component: itineraryDetail,
  },

  {
    path: "register",
    meta: {
      title: "注册",
    },
    component: register,
  },

  {
    path: "forgetPassword",
    meta: {
      title: "忘记密码",
    },
    component: forgetPassword,
  },
  {
    path: "companyIntroduction",
    meta: {
      title: "公司介绍",
    },
    component: companyIntroduction,
  },
  {
    path: "welfare",
    meta: {
      title: "薪资福利",
    },
    component: welfare,
  },
  {
    path: "recruitmentInformation",
    meta: {
      title: "校招信息",
    },
    component: recruitmentInformation,
  },
  {
    path: "onlineApplication",
    meta: {
      title: "网申面试干货",
    },
    component: onlineApplication,
  },
  {
    path: "treatmentDevelopment",
    meta: {
      title: "待遇发展",
    },
    component: treatmentDevelopment,
  },
  {
    path: "H5joblist",
    meta: {
      title: "行程职位表",
    },
    component: H5joblist,
  },

  {
    path: "personal",
    meta: {
      title: "个人中心",
    },
    component: personal,
  },
  {
    path: "resume",
    meta: {
      title: "我的简历",
    },
    component: resume,
  },
  {
    path: "deliver",
    meta: {
      title: "我的投递",
    },
    component: deliver,
  },
  {
    path: "deliverResume",
    meta: {
      title: "投递简历",
    },
    component: deliverResume,
  },

  {
    path: "editPassword",
    meta: {
      title: "修改密码",
    },
    component: editPassword,
  },

  {
    path: "",
    redirect: "home",
  },
  {
    path: "*",
    redirect: "home",
  },
];

export default pageRoute;
